export const EXPIRATION_TIME_MS = 600000; // 10 minutes
export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE_BYTES = 1024 * 1000 * MAX_FILE_SIZE_MB;
export const MAX_NUMBER_OF_FILES = 10;

// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
const IMAGE_FILES_ACCEPTED = [
  '.gif',
  '.jpeg',
  '.jpg',
  '.png',
  '.svg',
  '.webp',
  '.bmp',
  '.tif',
  '.tiff',
  '.heic',
];
const VIDEO_FILES_ACCEPTED = ['.3gpp', '.mp4', '.mov', '.avi', '.wmv', '.webm'];
const DOCUMENT_FILES_ACCEPTED = [
  '.pdf',
  '.csv',
  '.txt',
  '.rtf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.ods',
  '.tsv',
  '.odt',
  '.odm',
  '.odp',
];
const ARCHIVE_FILES_ACCEPTED = ['.rar', '.zip'];

export const WHITELISTED_EXTENSIONS = [
  ...IMAGE_FILES_ACCEPTED,
  ...VIDEO_FILES_ACCEPTED,
  ...DOCUMENT_FILES_ACCEPTED,
  ...ARCHIVE_FILES_ACCEPTED,
];
